import React from 'react';
import Card from 'components/cards/Card01';
import AnalyticsSerive from 'api/services/AnalyticsService';
import LayoutWrapper from 'components/LayoutWrapper';
import { useTranslation } from 'react-i18next';
import { getI18nValue } from 'utils/Utils';
import { useAxios } from 'hooks/useAxios';
import { RiUserVoiceFill } from 'react-icons/ri';
import PropTypes from 'prop-types';

function EscalationRateCard({ dateRanges, channel, language }) {
    const { t } = useTranslation();
    const [data, error, loading] = useAxios(
        AnalyticsSerive.getEscalationRate(dateRanges, channel, language)
    );

    return (
        <LayoutWrapper error={error} loading={loading} variant="cards" isEmpty={!loading && !data} className="h-full">
            {!!data && (
                <Card
                    title={t(getI18nValue('analytics.kpi.escalation_rate', 'title'))}
                    description={t(getI18nValue('analytics.kpi.escalation_rate', 'description'))}
                    value={`${data.escalation_rate}%`}
                    icon={<RiUserVoiceFill />}
                />
            )}
        </LayoutWrapper>
    );
}

EscalationRateCard.propTypes = {
  dateRanges: PropTypes.object.isRequired,
  channel: PropTypes.string,
  language: PropTypes.string,
};

export default EscalationRateCard;
